// -*-mode: rjsx -*-
// REACT
// eslint-disable-next-line
import React, { Component, useState, useEffect } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
import Help from "@material-ui/icons/HelpOutline"
import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"


// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"

// FLASH
import FlashLogo from "../../static/images/lightning-logo-transparent.png"
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
import FlashItem from "../Flash/FlashItem.js"
// import FlashRankCard from "../Flash/FlashRankCard.js"
import FlashRankList from "../Flash/FlashRankList.js"

// throws the error that it can onlyl be overriden
const localStyles = theme => createStyles({

    testDiv: {
        // mobile
        padding: 0,
        paddingTop: 90,
        marginTop: 0,
        marginBottom: 120,
        marginLeft: "auto",
        marginRight: "auto",

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    rootOverride: {
        margin: 5,
        width: 500,
        maxHeight: 34,
//        minHeight: 100,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        background: theme.palette.test.mainBG,
        //        background: theme.palette.test.bg2,
//        transition: "max-height .45s cubic-bezier(.44,.99,.48,1)",
    },

    rootExpandedOverride: {
        maxHeight: "none !important", // this will expand just to the height that's needed
        overflow: "hidden !important",
        background: theme.palette.test.fg3,
    },


    headerDiv: {
        marginLeft: 20,
        marginTop: 15,
        marginBottom: 20,
    },

    headerText: {
        fontSize: 30,
        fontWeight: 700,
        color: grey[800],
    },

    subheaderDiv: {
        marginLeft: 15,
        marginTop: 10,
        marginBottom: 0,
        width: "95%",
    },

    subheaderText: {
        fontSize: 21,
        fontWeight: 300,
        color: grey[800],
//        marginBottom: 5,
    },


    bnavbarRoot: {
        ...theme.css.bnavbarRoot,
        height: 72,
        borderTop: "1px solid",
        borderTopColor: grey[300],
	borderRadius: 0,
    },


    bnavbarButtonsDiv: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        height: 72,
//        paddingTop: 20,
//        paddingBottom: 20,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
	    maxWidth: 600,
        },

//        backgroundColor: grey[800],        
    },

    nextButtonDiv: {
        width: "30%",
        height: "55%",
//        backgroundColor: grey[100],
    },

    backButtonDiv: {
        width: "30%",
        height: "55%",
    },


    nextButton: {
//        margin: 20,
//        padding: 8,
        width: "100%",
        height: "100%",
        
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.nextButton,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.nextButtonLight,
        },
        
    },

    backButton: {
//        margin: 20,
//        padding: 8,
        width: "100%",
        height: "100%",
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    betweenSpace: {

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            width: 0,
        },
        
//        width: 100,
    },
    
    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        // test only for now
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // next to just to make them protrude
            // a bit more - better than sunken in
            // on a big screen
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
//            marginBottom: theme.css.separatorDiv.desktop.marginBottom,
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
//            borderRadius: theme.css.separatorDiv.desktop.borderRadius,
//            boxShadow: theme.css.separatorDiv.desktop.boxShadow,
        },
        
    },


    //
    // APPBAR
    //
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarPlus: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },

    appbarMessage: {
        ...theme.css.appbarMessage,
        color: "#FFFFFF",
    },
    
    menuButton: {
        marginRight: theme.spacing(2),
        color: "#FFFFFF",
    },
})

// eslint-disable-next-line
const useLocalStyles = makeStyles(localStyles, {name: "localStyles"})

class Tests extends Component {

    

    render() {
        
        const { classes }  = this.props

	return(
            <React.Fragment>
	      <CssBaseline/>
              <div className={clsx(classes.testDiv)}>


              {
                  //
                  // APPBAR
                  //
              }
                <AppBar className={clsx(classes.appbarRoot, classes.appbarPlus)} position="fixed" color="default">
                  <div style={{display: "flex", alignItems: "center"}}>
                    <div style={{display: "inline"}}>
                      <img alt="logo" src={FlashLogo} style={{display: "inline", width: 48, marginLeft: 8, marginTop: 5}}/>
                    </div>
                    <div style={{display: "inline"}}>
                      <Typography style={{ marginLeft: 20, color: "#FFFFFF"}} display="inline" className={classes.appbarMessage} variant="h6">
                        Your Issue
                      </Typography>
                    </div>
                  </div>
                  <div>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                      <MenuIcon  style={{fontSize: 35}}/>
                    </IconButton>
                  </div>
                </AppBar>
                
                <div className={classes.subheaderDiv}>
                  <div style={{display: "flex", alignItems: "center"}}>
                    <FlashItem
                      style={{backgroundColor: "#fafafa", width: "90%", maxHeight: 34}}
                      clickBody={true} hasMore={false} hasLess={false} expanded={false} fadeout={false}>
                      <div style={{display: "flex", alignItems: "center"}}>
                        <div>
                          <Help style={{fontSize: 30, color: grey[500], paddingTop: 0, marginRight: 5,}}/>
                        </div>
                        <div style={{marginBottom: 0}}>
                          <Typography className={classes.subheaderText} variant="h6">
                            Rank reasons by priority
                          </Typography>
                        </div>
                      </div>
                      <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                        <div style={{display: "inline"}}>To </div><div style={{display: "inline", fontWeight: "bold"}}>set</div><div style={{display: "inline"}}> rank, press checkbox multiple times.To </div><div style={{display: "inline", fontWeight: "bold"}}>unset</div><div style={{display: "inline"}}>, press on checkbox of reason with rank #1</div>
                      </Typography>
                    </FlashItem>
                  </div>

                </div>

                <div className={classes.headerDiv}>
                  <Typography className={classes.headerText} variant="h6">
                    Census questions about immigration status
                  </Typography>
                </div>

                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Reasons
                  </Typography>
                </div>

                
                <div>
                  <FlashRankList/>
                </div>
                {/*
                <FlashRankCard text="Question will frighten many and will result in undercount"/>
                <FlashRankCard text="Census helps define congressional districts - need to be based on citizens. More text going into another couple of lines. This is first extra sentence. This is second extra sentence."/>
                <FlashRankCard text="Illegals have been paying taxes & helping economy - need to be included"/>
                <FlashRankCard text="Illegals won't want to answer anyway"/>
                <FlashRankCard text="Citizenship question was used in past - just removed in 2010"/>
                <FlashRankCard text="Census needs to know head count for safety, education, healthcare"/>
                <FlashRankCard text="Constitution says 'persons' not citizens; try to count legals and illegals"/>
                 */}
              </div>


              <div className={classes.bnavbarRoot}>
                <div style={{display: "flex", alignItems:"center", justifyContent: "center"}}>
                  <div className={classes.bnavbarButtonsDiv}>
                    <div className={classes.backButtonDiv}>
                    <Button className={classes.backButton} onClick={this.handleBackClick}>back</Button>
                  </div>
                  <div className={classes.nextButtonDiv}>
                    <Button className={classes.nextButton} onClick={this.handleBackClick}>next</Button>
                  </div>
                </div>
                </div>            
              </div>

              
            </React.Fragment>
	)
    }
}

Tests.propTypes = {
    classes: PropTypes.object.isRequired,
}

// this is the cleanest
// we have to put commonStyles ahead
// of styles for styles to override it
export default withStyles(
    theme => ({
            ...globalStyles(theme),
            ...localStyles(theme),
        }),
    { name: "Tests" }
)(Tests)
